import React from 'react'
import { t } from 'src/translations'
import { FulfillmentType } from 'src/apollo/onlineOrdering'
import { toDayString, toLocalTimeWithTimezone } from 'shared/js/timeUtils'

interface FulfillmentTimeDisplayProps {
  className?: string
  testId: string
  translationPrefix: string
  cart: any
  onClick: () => void
  /** When false, ASAP is not valid (e.g. cart has preorder/TBR items) — show select-time instead of ASAP. */
  asapAvailable?: boolean
}

export const FulfillmentTimeDisplay = ({
  className,
  testId,
  translationPrefix,
  cart,
  onClick,
  asapAvailable = true
}: FulfillmentTimeDisplayProps) => {
  const getFulfillmentTimeDisplay = () => {
    if (!cart) return t(`${translationPrefix}.select-time`)

    if (
      cart.fulfillmentType === FulfillmentType.Future &&
      cart.fulfillmentDateTime
    ) {
      return `${toDayString(
        cart.fulfillmentDateTime
      )} ${toLocalTimeWithTimezone(cart.fulfillmentDateTime)}`
    }

    if (cart.fulfillmentType === FulfillmentType.Asap && !asapAvailable) {
      return t(`${translationPrefix}.select-time`)
    }

    const quoteTimeProperty = translationPrefix.includes('pickup')
      ? 'takeoutQuoteTime'
      : 'deliveryQuoteTime'
    const quoteTime = cart[quoteTimeProperty]

    if (quoteTime) {
      const asapText = t(`${translationPrefix}.asap`)
      const timeRange = `${quoteTime}-${quoteTime + 5} min`
      return `${asapText} • ${timeRange}`
    }

    return t(`${translationPrefix}.select-time`)
  }

  const getSubtitleKey = () => {
    return translationPrefix.includes('pickup')
      ? `${translationPrefix}.estimated-pickup-time`
      : `${translationPrefix}.estimated-delivery-time`
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick()
    }
  }

  return (
    <button
      className={`fulfillment-time-row ${className ?? ''}`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      data-testid={testId}
      type='button'
    >
      <div className='content'>
        <div className='title'>{getFulfillmentTimeDisplay()}</div>
        <div className='subtitle'>{t(getSubtitleKey())}</div>
      </div>
      <div className='chevron'>›</div>
    </button>
  )
}
